import styled from 'styled-components';

export const ItemContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  width: 335px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  box-shadow: 0px 4px 14px ${({ theme }) => theme.palette.darkTransparency};
  margin-bottom: ${({ theme }) => theme.spacing.base};
  @media (max-width: 330px) {
    width: 300px;
  }
`;

export const ControlledSubstanceIndicator = styled.div`
  color: ${({ theme }) => theme.palette.danger.main};
  background-color: ${({ theme }) => theme.palette.gray5};
  text-align: center;
  font-size: 14px;
  width: 90%;
  height: 30px;
  vertical-align: middle;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing.small};
  border-radius: 4px;
  font-weight: 600;
  word-break: break-all;
`;

export const MedicationTitleContainer = styled.div`
  color: ${({ theme }) => theme.palette.gray3};
  font-size: 14px;
  margin: ${({ theme }) => theme.spacing.small};
  display: flex;
  direction: row;
  width: 90%;
  margin-top: ${({ theme }) => theme.spacing.base};
`;
export const Divisor = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.palette.gray2}33;
  width: 95%;
  align-self: flex-end;
  margin-left: ${({ theme }) => theme.spacing.tiny};
  margin-top: ${({ theme }) => theme.spacing.tiny};
`;
export const MedicationTitle = styled.div`
  font-weight: 600;
  margin-right: 42px;
  margin-left: ${({ theme }) => theme.spacing.xSmall};
  position: relative;
  width: 90%;
  min-height: 30px;
  display: flex;
  align-items: center;
  word-break: break-all;
`;

export const MedicationActivePrinciple = styled.em`
  font-weight: 400;
  margin-right: 42px;
  margin-left: ${({ theme }) => theme.spacing.xSmall};
  margin-top: 4px;
  position: relative;
  width: 90%;
  display: flex;
  align-items: center;
  word-break: break-all;
  color: ${({ theme }) => theme.palette.gray1};
`;

export const MedicationIconWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.gray4};
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
`;

export const DescriptionWrapper = styled.div`
  width: 62%;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.gray3};
  margin-top: 0px;
  margin-bottom: ${({ theme }) => theme.spacing.base};
  white-space: pre-line;
  overflow-wrap: break-word;
  font-size: 14px;

  text-align: justify;
`;

export const BuyMedicationButton = styled.button`
  width: 100%;
  font-size: 11.5pt;
  color: #2493eb;
  padding-bottom: 20px;
  text-align: center;
  border: none;
  background-color: #fff;
  font-weight: 430;
`;

export const BuyMedicationTitle = styled.a`
  margin-right: 40px;
`;
